import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CONFIG from 'Config/settings';
import Modal, { Sheets, ModalHeader } from '@ingka/modal';
import checkmark from '@ingka/ssr-icon/paths/checkmark-small';
import informationCircle from '@ingka/ssr-icon/paths/information-circle';
import cross from '@ingka/ssr-icon/paths/cross-small';
import SSRIcon from '@ingka/ssr-icon';
import { t } from 'Utils/localization/i18next';
import { Text } from 'Common';
import styles from './CommunicationPreferences.module.scss';

class AttractNewCustomerFieldRead extends React.PureComponent {
  state = { modalOpen: false };

  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      showSuccessMessage: false,
      isConfirming: false
    };
    this.myRef = React.createRef();
  }

  scrollToCenter = () => {
    if (this.myRef) {
      this.myRef.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  setRef = node => {
    if (node) {
      this.myRef = node;
    }
  };

  render() {
    return (
      <React.Fragment>
        <div ref={this.setRef}>
          <Text>
            {t(`dashboard.communications.attract-customer.description`)}
          </Text>
          <Text
            marginBottom="s"
            className={styles['communication-preferences-description']}
            prefix={CONFIG.APP.STYLES_PREFIX}
          >
            {t('dashboard.communications.attract-customer.subtitle')}{' '}
            <SSRIcon
              prefix={CONFIG.APP.STYLES_PREFIX}
              viewBox="0 0 24 24"
              // viewBox="0 0 24 24"
              paths={informationCircle}
              onClick={() => {
                this.setState({ modalOpen: true });
              }}
            />
          </Text>
          <Text marginBottom="s">
            {this.props.profile.allowFindPotentialCustomers ? (
              <Text className={styles['sub-category-value']}>
                <span className={styles['subscribed-indicator']}>
                  <SSRIcon
                    prefix={CONFIG.APP.STYLES_PREFIX}
                    viewBox="0 0 24 24"
                    paths={checkmark}
                  />
                </span>
                {t(
                  `dashboard.communications.attract-customer.allow-share-data`
                )}
              </Text>
            ) : (
              <Text className={styles['sub-category-value']}>
                <span className={styles['unsubscribed-indicator']}>
                  <SSRIcon
                    prefix={CONFIG.APP.STYLES_PREFIX}
                    viewBox="0 0 24 24"
                    paths={cross}
                  />
                </span>
                {t(
                  `dashboard.communications.attract-customer.dont-allow-share-data`
                )}
              </Text>
            )}
          </Text>
          <div className={styles['section-read-unsubscribe-box']}>
            <Modal
              visible={this.state.modalOpen}
              escapable={true}
              handleCloseBtn={() => {
                this.setState({ modalOpen: false });
              }}
              prefix={CONFIG.APP.STYLES_PREFIX}
            >
              <Sheets
                header={<ModalHeader ariaCloseTxt={t('common.close')} />}
                prefix={CONFIG.APP.STYLES_PREFIX}
              >
                <div className={styles['personalised-ads']}>
                  <Text className={styles['info-header']} bold marginBottom="m">
                    {t(
                      'dashboard.communications.attract-customer.modal-header'
                    )}
                  </Text>
                  <Text marginBottom="s">
                    {t(
                      'dashboard.communications.attract-customer.modal-description-1'
                    )}
                  </Text>
                  {this.props.modalDescription2 && (
                    <Text marginBottom="s">
                      {t(
                        'dashboard.communications.attract-customer.modal-description-2'
                      )}
                    </Text>
                  )}
                </div>
              </Sheets>
            </Modal>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

AttractNewCustomerFieldRead.propTypes = {
  profile: PropTypes.object,
  modalDescription1: PropTypes.bool,
  modalDescription2: PropTypes.bool
};

AttractNewCustomerFieldRead.defaultProps = {
  modalDescription1: false,
  modalDescription2: false
};

const mapStateToProps = state => {
  return {
    profile: state.profile
  };
};

export default connect(mapStateToProps)(AttractNewCustomerFieldRead);
